import { render, staticRenderFns } from "./Opens.vue?vue&type=template&id=44557d67&"
import script from "./Opens.vue?vue&type=script&lang=ts&"
export * from "./Opens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports